module.exports = __webpack_public_path__ + "img/652.22d84882.jpg";